export const workExperienceData = [
  {
    id: 'xiaomi-senior-pm',
    company: 'xiaomi',
    role: 'senior-product-manager',
    title: 'Senior Product Manager, AI & Data',
    companyDisplay: 'Xiaomi',
    location: 'Beijing, China',
    duration: 'Jan 2024 – Present',
    status: 'current',
    summary: 'Forward-deployed PM for South Asia commercial operations, shipping LLM-powered AI agents and data products.',
    tags: ['AI Agents', 'LLM & MCP', 'Data Products', 'Forward-Deployed'],
    metrics: ['100% adoption across 5 markets', '50% efficiency improvement', '100% BI dashboard adoption'],
    overview: 'Own the AI and data product roadmap for South Asia commercial operations: CRM, PRM, incentive systems, demand analytics and reporting. I work in a forward-deployed (FDE) model, embedded with business teams and prototyping working tools in code instead of handing off specs.',
    achievements: [
      'Drove 100% adoption across 5 markets by designing and shipping LLM-powered AI agents for commercial teams, built on Model Context Protocol (MCP), agentic workflows and natural-language-to-SQL/Hive',
      'Improved operational efficiency 50% by consolidating fragmented commercial tools into one AI-driven system',
      'Scaled BI dashboard adoption to 100% across 5 markets by leading GenAI forecasting, reporting and demand-insight initiatives',
      'Shortened the product-to-build loop by working in a forward-deployed (FDE) model: embedding with business teams and prototyping working LLM tools with AI-assisted development (Claude Code, Cursor)'
    ],
    techStack: ['LLMs', 'AI Agents', 'Model Context Protocol (MCP)', 'Natural-language-to-SQL', 'Hive', 'Power BI', 'Claude Code', 'Cursor'],
    businessOutcomes: ['100% adoption across 5 markets', '50% operational efficiency gain', '100% BI dashboard adoption'],
    challenges: [
      'Getting AI tools adopted by busy commercial teams, not just demoed',
      'Keeping answers trustworthy on top of complex, multi-market data',
      'Prototyping fast while staying within enterprise data and security rules'
    ],
    zh: {
      title: '高级产品经理（AI 与数据）',
      companyDisplay: '小米 (Xiaomi)',
      location: '中国 · 北京',
      duration: '2024年1月 – 至今',
      summary: '以 Forward-Deployed 模式服务南亚商业运营，交付基于大语言模型的 AI Agent 与数据产品。',
      tags: ['AI Agent', 'LLM 与 MCP', '数据产品', 'Forward-Deployed'],
      metrics: ['5 个市场 100% 采用', '运营效率提升 50%', 'BI 看板 100% 采用'],
      overview: '负责南亚商业运营的 AI 与数据产品路线图，覆盖 CRM、PRM、激励系统、需求分析与报表。以 Forward-Deployed（FDE）模式深入业务团队，直接编写可用原型，取代传统的需求文档交接。',
      achievements: [
        '设计并上线面向商业团队、基于大语言模型的 AI Agent（采用 Model Context Protocol (MCP)、智能体工作流和自然语言转 SQL/Hive），在 5 个市场实现 100% 采用',
        '将分散的商业工具整合为统一的 AI 驱动系统，运营效率提升 50%',
        '主导生成式 AI 驱动的预测、报表与需求洞察项目，使 BI 看板在 5 个市场的采用率达到 100%',
        '以 Forward-Deployed（FDE）模式深入业务团队，借助 AI 辅助开发（Claude Code、Cursor）直接构建可用的 LLM 工具原型，缩短从产品到开发的周期'
      ],
      businessOutcomes: ['5 个市场 100% 采用', '运营效率提升 50%', 'BI 看板采用率 100%'],
      challenges: [
        '让 AI 工具真正被繁忙的商业团队用起来，而不只是演示',
        '在复杂的多市场数据之上保证结果可信',
        '在快速原型与企业数据安全规范之间取得平衡'
      ]
    },
    vi: {
      title: 'Quản lý sản phẩm cấp cao, AI & Dữ liệu',
      companyDisplay: 'Xiaomi',
      location: 'Bắc Kinh, Trung Quốc',
      duration: '01/2024 – Hiện tại',
      summary: 'PM theo mô hình forward-deployed cho hoạt động kinh doanh khu vực Nam Á, triển khai AI agent dựa trên LLM và sản phẩm dữ liệu.',
      tags: ['AI Agent', 'LLM & MCP', 'Sản phẩm dữ liệu', 'Forward-Deployed'],
      metrics: ['100% sử dụng tại 5 thị trường', 'Tăng 50% hiệu suất', '100% sử dụng dashboard BI'],
      overview: 'Phụ trách lộ trình sản phẩm AI và dữ liệu cho hoạt động kinh doanh khu vực Nam Á: CRM, PRM, hệ thống khuyến khích, phân tích nhu cầu và báo cáo. Làm việc theo mô hình forward-deployed (FDE): gắn trực tiếp với các nhóm kinh doanh và tự xây dựng bản mẫu hoạt động thay vì chỉ bàn giao đặc tả.',
      achievements: [
        'Đạt 100% mức sử dụng tại 5 thị trường nhờ thiết kế và triển khai AI agent dựa trên LLM cho các nhóm kinh doanh, xây dựng trên Model Context Protocol (MCP), quy trình agentic và chuyển ngôn ngữ tự nhiên thành SQL/Hive',
        'Tăng 50% hiệu suất vận hành bằng cách hợp nhất các công cụ kinh doanh rời rạc thành một hệ thống vận hành bằng AI',
        'Đưa mức sử dụng dashboard BI lên 100% tại 5 thị trường nhờ dẫn dắt các sáng kiến dự báo, báo cáo và phân tích nhu cầu bằng GenAI',
        'Rút ngắn vòng lặp từ sản phẩm đến phát triển nhờ mô hình forward-deployed (FDE): gắn với nhóm kinh doanh và tự xây dựng công cụ LLM bằng phát triển có hỗ trợ AI (Claude Code, Cursor)'
      ],
      businessOutcomes: ['100% sử dụng tại 5 thị trường', 'Tăng 50% hiệu suất vận hành', '100% sử dụng dashboard BI'],
      challenges: [
        'Giúp các nhóm kinh doanh bận rộn thực sự sử dụng công cụ AI, không chỉ xem demo',
        'Đảm bảo kết quả đáng tin cậy trên dữ liệu đa thị trường phức tạp',
        'Cân bằng giữa tạo bản mẫu nhanh và quy định bảo mật dữ liệu doanh nghiệp'
      ]
    }
  },
  {
    id: 'flashintel-project-leader',
    company: 'flashintel',
    role: 'project-leader',
    title: 'Product Leader',
    companyDisplay: 'FlashLabs (formerly FlashIntel)',
    location: 'Shanghai, China',
    duration: 'Feb 2023 – Jan 2024',
    status: 'previous',
    summary: 'Led product strategy and go-to-market for a B2B SaaS CRM and sales-intelligence platform.',
    tags: ['B2B SaaS', 'CRM', 'Sales Intelligence', 'Go-to-Market'],
    metrics: ['30% enterprise sign-up growth', '25% ROI improvement', '15% churn reduction'],
    overview: 'Led product strategy and go-to-market for a B2B SaaS CRM and sales-intelligence platform, turning customer and market signals into roadmap bets.',
    achievements: [
      'Grew enterprise sign-ups 30% and improved ROI 25% by leading product strategy and go-to-market for a B2B SaaS CRM and sales-intelligence platform',
      'Cut churn 15% and grew upsell 10% by building engagement tracking, pipeline management and performance analytics',
      'Kept 90% of sprints on time across concurrent workstreams while introducing AI-assisted prototyping for rapid validation'
    ],
    techStack: ['B2B SaaS', 'CRM', 'Sales Intelligence', 'Pipeline Analytics', 'AI-assisted Prototyping'],
    businessOutcomes: ['30% enterprise sign-up growth', '25% ROI improvement', '15% lower churn, 10% more upsell'],
    challenges: [
      'Prioritizing across sales, marketing and customer success requests',
      'Proving value quickly to enterprise buyers',
      'Keeping delivery predictable across concurrent workstreams'
    ],
    zh: {
      title: '产品负责人',
      companyDisplay: 'FlashLabs（原 FlashIntel）',
      location: '中国 · 上海',
      duration: '2023年2月 – 2024年1月',
      summary: '主导 B2B SaaS CRM 与销售情报平台的产品战略和市场进入。',
      tags: ['B2B SaaS', 'CRM', '销售情报', '市场进入（GTM）'],
      metrics: ['企业客户注册增长 30%', 'ROI 提升 25%', '客户流失率降低 15%'],
      overview: '主导 B2B SaaS CRM 与销售情报平台的产品战略和市场进入（GTM），将客户与市场信号转化为路线图决策。',
      achievements: [
        '主导 B2B SaaS CRM 与销售情报平台的产品战略和市场进入（GTM），企业客户注册增长 30%，ROI 提升 25%',
        '搭建用户参与度追踪、销售管道管理和绩效分析，客户流失率降低 15%，增购提升 10%',
        '引入 AI 辅助原型进行快速验证，在多条并行工作流中保持 90% 的迭代按时交付率'
      ],
      businessOutcomes: ['企业客户注册增长 30%', 'ROI 提升 25%', '流失率降低 15%，增购提升 10%'],
      challenges: [
        '在销售、市场与客户成功团队的需求之间确定优先级',
        '快速向企业客户证明产品价值',
        '在多条并行工作流中保持可预期的交付节奏'
      ]
    },
    vi: {
      title: 'Trưởng sản phẩm',
      companyDisplay: 'FlashLabs (trước đây là FlashIntel)',
      location: 'Thượng Hải, Trung Quốc',
      duration: '02/2023 – 01/2024',
      summary: 'Dẫn dắt chiến lược sản phẩm và go-to-market cho nền tảng B2B SaaS về CRM và thông tin bán hàng.',
      tags: ['B2B SaaS', 'CRM', 'Thông tin bán hàng', 'Go-to-Market'],
      metrics: ['Tăng 30% đăng ký doanh nghiệp', 'Cải thiện 25% ROI', 'Giảm 15% tỷ lệ rời bỏ'],
      overview: 'Dẫn dắt chiến lược sản phẩm và go-to-market cho nền tảng B2B SaaS về CRM và thông tin bán hàng, biến tín hiệu từ khách hàng và thị trường thành các quyết định trong lộ trình.',
      achievements: [
        'Tăng 30% lượt đăng ký doanh nghiệp và cải thiện 25% ROI nhờ dẫn dắt chiến lược sản phẩm và go-to-market cho nền tảng B2B SaaS về CRM và thông tin bán hàng',
        'Giảm 15% tỷ lệ rời bỏ và tăng 10% bán thêm nhờ xây dựng theo dõi tương tác, quản lý pipeline và phân tích hiệu suất',
        'Duy trì 90% sprint đúng hạn trên nhiều luồng công việc song song, đồng thời áp dụng tạo bản mẫu có hỗ trợ AI để xác thực nhanh'
      ],
      businessOutcomes: ['Tăng 30% đăng ký doanh nghiệp', 'Cải thiện 25% ROI', 'Giảm 15% rời bỏ, tăng 10% bán thêm'],
      challenges: [
        'Ưu tiên giữa yêu cầu của nhóm bán hàng, marketing và chăm sóc khách hàng',
        'Chứng minh giá trị nhanh chóng với khách hàng doanh nghiệp',
        'Giữ tiến độ bàn giao ổn định trên nhiều luồng công việc song song'
      ]
    }
  },
  {
    id: 'wemero-senior-pm',
    company: 'wemero',
    role: 'senior-product-manager',
    title: 'Senior Product Manager',
    companyDisplay: 'Wemero',
    location: 'Beijing, China',
    duration: 'Oct 2019 – Feb 2023',
    status: 'previous',
    summary: 'Built a B2B2C SaaS product from scratch, reaching 1,200+ active users in year one.',
    tags: ['B2B2C SaaS', '0→1 Build', 'Product Analytics', 'Pricing'],
    metrics: ['1,200+ active users in year one', '50% conversion increase', '25% volume growth'],
    overview: 'Built a B2B2C SaaS product from scratch for beauty, fitness and clinic businesses, and owned its vision, planning and design.',
    achievements: [
      'Launched a B2B2C SaaS product from scratch for beauty, fitness and clinic businesses, reaching 1,200+ active users in year one',
      'Raised conversion 50% and sign-ups 15% by implementing user-behavior analytics',
      'Grew volume 25% by designing pricing and referral systems',
      'Led product vision, planning and design with multidisciplinary teams, turning roadmaps into actionable backlogs'
    ],
    techStack: ['B2B2C SaaS', 'User Behavior Analytics', 'Pricing & Referral Systems', 'Agile'],
    businessOutcomes: ['1,200+ active users in year one', '50% conversion increase', '25% volume growth'],
    challenges: [
      'Defining a new product from zero',
      'Serving three different business types with one product',
      'Balancing merchant adoption with sustainable pricing'
    ],
    zh: {
      title: '高级产品经理',
      companyDisplay: 'Wemero',
      location: '中国 · 北京',
      duration: '2019年10月 – 2023年2月',
      summary: '从零打造 B2B2C SaaS 产品，首年获得 1,200+ 活跃用户。',
      tags: ['B2B2C SaaS', '从 0 到 1', '产品分析', '定价策略'],
      metrics: ['首年 1,200+ 活跃用户', '转化率提升 50%', '业务量增长 25%'],
      overview: '从零打造面向美业、健身和诊所行业的 B2B2C SaaS 产品，并负责其产品愿景、规划与设计。',
      achievements: [
        '从零打造面向美业、健身和诊所行业的 B2B2C SaaS 产品，首年获得 1,200+ 活跃用户',
        '落地用户行为分析，转化率提升 50%，注册量提升 15%',
        '设计定价与推荐体系，业务量增长 25%',
        '主导产品愿景、规划与设计，与跨职能团队协作，将路线图拆解为可执行的需求池'
      ],
      businessOutcomes: ['首年 1,200+ 活跃用户', '转化率提升 50%', '业务量增长 25%'],
      challenges: [
        '从零定义一个全新的产品',
        '用一个产品服务三类业务差异明显的行业',
        '在商户采用门槛与可持续定价之间取得平衡'
      ]
    },
    vi: {
      title: 'Quản lý sản phẩm cấp cao',
      companyDisplay: 'Wemero',
      location: 'Bắc Kinh, Trung Quốc',
      duration: '10/2019 – 02/2023',
      summary: 'Xây dựng sản phẩm B2B2C SaaS từ con số không, đạt hơn 1.200 người dùng hoạt động trong năm đầu.',
      tags: ['B2B2C SaaS', 'Xây dựng 0→1', 'Phân tích sản phẩm', 'Định giá'],
      metrics: ['Hơn 1.200 người dùng hoạt động năm đầu', 'Tăng 50% tỷ lệ chuyển đổi', 'Tăng 25% sản lượng'],
      overview: 'Xây dựng sản phẩm B2B2C SaaS từ con số không cho các doanh nghiệp làm đẹp, thể hình và phòng khám, phụ trách tầm nhìn, kế hoạch và thiết kế sản phẩm.',
      achievements: [
        'Ra mắt sản phẩm B2B2C SaaS từ con số không cho lĩnh vực làm đẹp, thể hình và phòng khám, đạt hơn 1.200 người dùng hoạt động trong năm đầu',
        'Tăng 50% tỷ lệ chuyển đổi và 15% lượt đăng ký nhờ triển khai phân tích hành vi người dùng',
        'Tăng 25% sản lượng nhờ thiết kế hệ thống định giá và giới thiệu',
        'Dẫn dắt tầm nhìn, kế hoạch và thiết kế sản phẩm cùng các nhóm liên chức năng, chuyển lộ trình thành backlog có thể thực thi'
      ],
      businessOutcomes: ['Hơn 1.200 người dùng hoạt động', 'Tăng 50% tỷ lệ chuyển đổi', 'Tăng 25% sản lượng'],
      challenges: [
        'Định hình một sản phẩm mới từ con số không',
        'Phục vụ ba loại hình kinh doanh khác nhau bằng một sản phẩm',
        'Cân bằng giữa mức độ chấp nhận của đối tác và định giá bền vững'
      ]
    }
  },
  {
    id: 'idata-data-pm',
    company: 'idata',
    role: 'data-product-manager',
    title: 'Data Product Manager',
    companyDisplay: 'Wemero',
    location: 'Beijing, China',
    duration: 'Sep 2018 – Oct 2019',
    status: 'previous',
    summary: 'Defined the vision and roadmap for a Customer Data Platform, driving 90% customer-acquisition growth.',
    tags: ['Data Products', 'CDP', 'Business Intelligence', 'Analytics'],
    metrics: ['90% customer acquisition growth', '40% user-analysis improvement', '80% targeting-accuracy improvement'],
    overview: 'Defined the vision and roadmap for a Customer Data Platform (CDP) and Business Data Platform (BDP) supporting demand, marketing and commercial operations.',
    achievements: [
      'Grew customer acquisition 90% by turning stakeholder needs into data products on a Customer Data Platform and Business Data Platform',
      'Improved user analysis 40% and targeting accuracy 80% with Big Data, ETL, predictive analytics and behavioral segmentation',
      'Defined the CDP and BDP vision and roadmap with engineering, marketing and insights teams'
    ],
    techStack: ['CDP', 'BDP', 'Big Data', 'ETL', 'Predictive Analytics', 'Segmentation'],
    businessOutcomes: ['90% customer acquisition growth', '40% user-analysis improvement', '80% targeting-accuracy improvement'],
    challenges: [
      'Aligning several business units on shared data definitions',
      'Turning raw data into tools marketers could use',
      'Balancing data-platform depth with near-term business needs'
    ],
    zh: {
      title: '数据产品经理',
      companyDisplay: 'Wemero',
      location: '中国 · 北京',
      duration: '2018年9月 – 2019年10月',
      summary: '为客户数据平台（CDP）制定愿景与路线图，获客增长 90%。',
      tags: ['数据产品', 'CDP', '商业智能（BI）', '数据分析'],
      metrics: ['获客增长 90%', '用户分析效率提升 40%', '定向精准度提升 80%'],
      overview: '为支撑需求、营销和商业运营的客户数据平台（CDP）与业务数据平台（BDP）制定愿景和路线图。',
      achievements: [
        '将业务需求转化为客户数据平台（CDP）和业务数据平台（BDP）上的数据产品，获客增长 90%',
        '借助大数据、ETL、预测分析和用户行为分群，用户分析效率提升 40%，定向精准度提升 80%',
        '与研发、市场和洞察团队一起制定 CDP 与 BDP 的愿景和路线图'
      ],
      businessOutcomes: ['获客增长 90%', '用户分析效率提升 40%', '定向精准度提升 80%'],
      challenges: [
        '让多个业务部门对统一的数据口径达成一致',
        '把原始数据变成营销人员能直接使用的工具',
        '在数据平台的长期建设与短期业务需求之间取得平衡'
      ]
    },
    vi: {
      title: 'Quản lý sản phẩm dữ liệu',
      companyDisplay: 'Wemero',
      location: 'Bắc Kinh, Trung Quốc',
      duration: '09/2018 – 10/2019',
      summary: 'Định hình tầm nhìn và lộ trình cho Nền tảng dữ liệu khách hàng (CDP), thúc đẩy tăng 90% lượng khách hàng mới.',
      tags: ['Sản phẩm dữ liệu', 'CDP', 'Trí tuệ kinh doanh (BI)', 'Phân tích'],
      metrics: ['Tăng 90% thu hút khách hàng', 'Cải thiện 40% phân tích người dùng', 'Tăng 80% độ chính xác nhắm mục tiêu'],
      overview: 'Định hình tầm nhìn và lộ trình cho Nền tảng dữ liệu khách hàng (CDP) và Nền tảng dữ liệu kinh doanh (BDP) phục vụ nhu cầu, marketing và vận hành kinh doanh.',
      achievements: [
        'Tăng 90% lượng khách hàng mới nhờ biến nhu cầu của các bên liên quan thành sản phẩm dữ liệu trên CDP và BDP',
        'Cải thiện 40% phân tích người dùng và 80% độ chính xác nhắm mục tiêu nhờ Big Data, ETL, phân tích dự báo và phân khúc theo hành vi',
        'Định hình tầm nhìn và lộ trình CDP và BDP cùng các nhóm kỹ thuật, marketing và phân tích'
      ],
      businessOutcomes: ['Tăng 90% thu hút khách hàng', 'Cải thiện 40% phân tích người dùng', 'Tăng 80% độ chính xác nhắm mục tiêu'],
      challenges: [
        'Thống nhất định nghĩa dữ liệu chung giữa nhiều đơn vị kinh doanh',
        'Biến dữ liệu thô thành công cụ mà đội marketing có thể sử dụng',
        'Cân bằng giữa xây dựng nền tảng dữ liệu dài hạn và nhu cầu kinh doanh ngắn hạn'
      ]
    }
  },
  {
    id: 'tradebees-pm',
    company: 'tradebees',
    role: 'product-manager',
    title: 'Product Manager',
    companyDisplay: 'TradeBees Inc.',
    location: 'Beijing, China',
    duration: 'Jul 2016 – Sep 2018',
    status: 'previous',
    summary: 'Built a B2C marketplace and B2B web platform for copyright trading, growing transactions 280% in 6 months.',
    tags: ['B2C Marketplace', 'B2B Platform', 'Pricing', 'Cross-regional Teams'],
    metrics: ['280% transaction growth in 6 months', '60% product growth', '20% LTV increase'],
    overview: 'Built a B2C marketplace and B2B web platform for copyright transactions, working with teams across APAC, Japan, EMEA and the Americas.',
    achievements: [
      'Grew transactions 280% in 6 months by building a B2C marketplace and B2B web platform for copyright trading',
      'Increased customer lifetime value 20% through long-term pricing strategy',
      'Delivered 60% product growth by coordinating teams across APAC, Japan, EMEA and the Americas'
    ],
    techStack: ['B2C Marketplace', 'B2B Web Platform', 'Pricing Strategy', 'Cross-regional Operations'],
    businessOutcomes: ['280% transaction growth in 6 months', '60% product growth', '20% LTV increase'],
    challenges: [
      'Coordinating teams across four regions and time zones',
      'Serving both B2C buyers and B2B partners on one platform',
      'Pricing for long-term customer value'
    ],
    zh: {
      title: '产品经理',
      companyDisplay: 'TradeBees Inc.（北京易蜂信息科技有限公司）',
      location: '中国 · 北京',
      duration: '2016年7月 – 2018年9月',
      summary: '打造面向版权交易的 B2C 交易市场和 B2B Web 平台，6 个月内交易量增长 280%。',
      tags: ['B2C 交易市场', 'B2B 平台', '定价策略', '跨区域团队'],
      metrics: ['6 个月交易量增长 280%', '产品增长 60%', '客户生命周期价值提升 20%'],
      overview: '打造面向版权交易的 B2C 交易市场和 B2B Web 平台，并与亚太、日本、欧洲中东非洲和美洲团队协作。',
      achievements: [
        '打造面向版权交易的 B2C 交易市场和 B2B Web 平台，6 个月内交易量增长 280%',
        '制定长期定价策略，客户生命周期价值提升 20%',
        '协调亚太、日本、欧洲中东非洲和美洲团队，推动产品增长 60%'
      ],
      businessOutcomes: ['6 个月交易量增长 280%', '产品增长 60%', '客户生命周期价值提升 20%'],
      challenges: [
        '协调横跨四个区域、多个时区的团队',
        '在同一平台上同时服务 B2C 买家与 B2B 合作伙伴',
        '以长期客户价值为导向制定定价'
      ]
    },
    vi: {
      title: 'Quản lý sản phẩm',
      companyDisplay: 'TradeBees Inc.',
      location: 'Bắc Kinh, Trung Quốc',
      duration: '07/2016 – 09/2018',
      summary: 'Xây dựng sàn giao dịch B2C và nền tảng web B2B cho giao dịch bản quyền, tăng 280% giao dịch trong 6 tháng.',
      tags: ['Sàn giao dịch B2C', 'Nền tảng B2B', 'Định giá', 'Nhóm liên khu vực'],
      metrics: ['Tăng 280% giao dịch trong 6 tháng', 'Tăng 60% sản phẩm', 'Tăng 20% LTV'],
      overview: 'Xây dựng sàn giao dịch B2C và nền tảng web B2B cho giao dịch bản quyền, phối hợp với các nhóm tại Châu Á - Thái Bình Dương, Nhật Bản, EMEA và Châu Mỹ.',
      achievements: [
        'Tăng 280% giao dịch trong 6 tháng nhờ xây dựng sàn giao dịch B2C và nền tảng web B2B cho giao dịch bản quyền',
        'Tăng 20% giá trị vòng đời khách hàng nhờ chiến lược định giá dài hạn',
        'Đạt mức tăng trưởng sản phẩm 60% nhờ điều phối các nhóm tại Châu Á - Thái Bình Dương, Nhật Bản, EMEA và Châu Mỹ'
      ],
      businessOutcomes: ['Tăng 280% giao dịch trong 6 tháng', 'Tăng 60% sản phẩm', 'Tăng 20% LTV'],
      challenges: [
        'Điều phối các nhóm ở bốn khu vực và nhiều múi giờ',
        'Phục vụ cả người mua B2C và đối tác B2B trên một nền tảng',
        'Định giá hướng tới giá trị khách hàng dài hạn'
      ]
    }
  },
  {
    id: 'wipro-project-engineer',
    company: 'wipro',
    role: 'project-engineer',
    title: 'Project Engineer',
    companyDisplay: 'Wipro',
    location: 'Chennai, India',
    duration: 'Jan 2014 – Jun 2016',
    status: 'previous',
    summary: 'Built ELT pipelines and data integrations, and improved a fraud-detection system for Citi.',
    tags: ['Data Engineering', 'ELT', 'Oracle', 'Fraud Detection'],
    metrics: ['90% better data access for analysts', '30% fraud-analysis improvement', 'Python/MySQL BI tool'],
    overview: 'Worked on data pipelines, multi-source data integration and fraud analytics for enterprise clients, including Citi credit cards.',
    achievements: [
      'Improved analyst data access 90% by designing ELT pipelines that integrated multiple data sources into Oracle-based business systems',
      'Raised fraud-analysis effectiveness 30% for Citi credit-card clients by enhancing a fraud-detection system with the onsite Citi team',
      'Built a Python/MySQL BI tool that tracked ticket updates and improved support team productivity'
    ],
    techStack: ['ELT', 'Oracle', 'Data Integration', 'Fraud Detection', 'Python', 'MySQL'],
    businessOutcomes: ['90% better data access for analysts', '30% fraud-analysis improvement'],
    challenges: [
      'Integrating data from many different source systems',
      'Improving fraud detection without blocking genuine customers',
      'Working across onsite and offshore teams'
    ],
    zh: {
      title: '项目工程师',
      companyDisplay: 'Wipro (维布络)',
      location: '印度 · 金奈',
      duration: '2014年1月 – 2016年6月',
      summary: '构建 ELT 数据管道与多源数据集成，并为花旗优化欺诈检测系统。',
      tags: ['数据工程', 'ELT', 'Oracle', '欺诈检测'],
      metrics: ['分析师数据可访问性提升 90%', '欺诈分析效果提升 30%', 'Python/MySQL BI 工具'],
      overview: '为企业客户（包括花旗信用卡业务）负责数据管道、多源数据集成与欺诈分析相关工作。',
      achievements: [
        '设计 ELT 数据管道，将多源数据集成到基于 Oracle 的业务系统，分析师数据可访问性提升 90%',
        '与花旗现场团队合作优化欺诈检测系统，为花旗信用卡客户提升欺诈分析效果 30%',
        '使用 Python/MySQL 构建 BI 工具，追踪工单进度，提升支持团队工作效率'
      ],
      businessOutcomes: ['分析师数据可访问性提升 90%', '欺诈分析效果提升 30%'],
      challenges: [
        '集成来自多个不同源系统的数据',
        '提升欺诈检测效果的同时不误拦正常用户',
        '与现场团队和离岸团队协同工作'
      ]
    },
    vi: {
      title: 'Kỹ sư dự án',
      companyDisplay: 'Wipro',
      location: 'Chennai, Ấn Độ',
      duration: '01/2014 – 06/2016',
      summary: 'Xây dựng pipeline ELT, tích hợp dữ liệu đa nguồn và cải thiện hệ thống phát hiện gian lận cho Citi.',
      tags: ['Kỹ thuật dữ liệu', 'ELT', 'Oracle', 'Phát hiện gian lận'],
      metrics: ['Cải thiện 90% truy cập dữ liệu', 'Cải thiện 30% phân tích gian lận', 'Công cụ BI Python/MySQL'],
      overview: 'Phụ trách pipeline dữ liệu, tích hợp dữ liệu đa nguồn và phân tích gian lận cho khách hàng doanh nghiệp, bao gồm mảng thẻ tín dụng của Citi.',
      achievements: [
        'Cải thiện 90% khả năng truy cập dữ liệu cho chuyên viên phân tích nhờ thiết kế pipeline ELT tích hợp nhiều nguồn dữ liệu vào hệ thống Oracle',
        'Cải thiện 30% hiệu quả phân tích gian lận cho khách hàng thẻ tín dụng Citi nhờ nâng cấp hệ thống phát hiện gian lận cùng nhóm Citi tại chỗ',
        'Xây dựng công cụ BI bằng Python/MySQL để theo dõi cập nhật ticket, nâng cao năng suất của nhóm hỗ trợ'
      ],
      businessOutcomes: ['Cải thiện 90% truy cập dữ liệu', 'Cải thiện 30% phân tích gian lận'],
      challenges: [
        'Tích hợp dữ liệu từ nhiều hệ thống nguồn khác nhau',
        'Cải thiện phát hiện gian lận mà không chặn nhầm khách hàng thật',
        'Phối hợp giữa nhóm tại chỗ và nhóm offshore'
      ]
    }
  },
  {
    id: 'cris-intern',
    company: 'cris',
    role: 'data-engineering-intern',
    title: 'Data Engineering Intern',
    companyDisplay: 'CRIS (Centre for Railway Information Systems)',
    location: 'New Delhi, India',
    duration: 'May 2013 – Dec 2013',
    status: 'previous',
    summary: 'Built a Business Intelligence tool and assisted with product documentation.',
    tags: ['Data Engineering', 'Business Intelligence', 'Python', 'MySQL'],
    metrics: ['40% support productivity boost', 'Passenger Reservation System'],
    overview: 'Worked with the Chief Systems Administration team on Passenger Reservation System modules.',
    achievements: [
      'Built a Business Intelligence tool with Python and MySQL that raised support productivity 40% by tracking ticket updates',
      'Assisted the Product Manager with PRD/MRD documentation and prototype designs'
    ],
    techStack: ['Python', 'MySQL', 'Business Intelligence', 'PRD/MRD'],
    businessOutcomes: ['40% support productivity boost'],
    challenges: [
      'Learning a large railway reservation system quickly',
      'Building a BI tool from scratch',
      'Writing requirement documents and prototypes'
    ],
    zh: {
      title: '数据工程实习生',
      companyDisplay: 'CRIS（印度铁路信息系统中心）',
      location: '印度 · 新德里',
      duration: '2013年5月 – 2013年12月',
      summary: '使用 Python 和 MySQL 构建 BI 工具，并协助产品经理完成需求文档与原型设计。',
      tags: ['数据工程', '商业智能（BI）', 'Python', 'MySQL'],
      metrics: ['支持效率提升 40%', '旅客订票系统（PRS）'],
      overview: '协助系统管理团队维护旅客订票系统（PRS）相关模块。',
      achievements: [
        '使用 Python 和 MySQL 构建 BI 工具，通过追踪工单进度使支持效率提升 40%',
        '协助产品经理编写 PRD/MRD 文档，并参与原型设计'
      ],
      businessOutcomes: ['支持效率提升 40%'],
      challenges: [
        '快速理解大型铁路订票系统的业务逻辑',
        '从零构建 BI 工具',
        '编写需求文档并参与原型设计'
      ]
    },
    vi: {
      title: 'Thực tập sinh Kỹ thuật dữ liệu',
      companyDisplay: 'CRIS (Trung tâm Hệ thống Thông tin Đường sắt)',
      location: 'New Delhi, Ấn Độ',
      duration: '05/2013 – 12/2013',
      summary: 'Xây dựng công cụ Business Intelligence và hỗ trợ soạn thảo tài liệu sản phẩm.',
      tags: ['Kỹ thuật dữ liệu', 'Trí tuệ kinh doanh (BI)', 'Python', 'MySQL'],
      metrics: ['Tăng 40% năng suất hỗ trợ', 'Hệ thống đặt chỗ hành khách'],
      overview: 'Phối hợp với nhóm Quản trị hệ thống trong việc quản lý các mô-đun của Hệ thống đặt chỗ hành khách (PRS).',
      achievements: [
        'Xây dựng công cụ Business Intelligence bằng Python và MySQL, tăng 40% năng suất hỗ trợ nhờ theo dõi cập nhật ticket',
        'Hỗ trợ Quản lý sản phẩm soạn thảo tài liệu PRD/MRD và thiết kế bản mẫu'
      ],
      businessOutcomes: ['Tăng 40% năng suất hỗ trợ'],
      challenges: [
        'Nhanh chóng nắm bắt một hệ thống đặt vé đường sắt lớn',
        'Xây dựng công cụ BI từ con số không',
        'Soạn thảo tài liệu yêu cầu và thiết kế bản mẫu'
      ]
    }
  }
];

const LOCALIZED_EXPERIENCE_FIELDS = [
  'title',
  'companyDisplay',
  'location',
  'duration',
  'summary',
  'tags',
  'metrics',
  'overview',
  'achievements',
  'businessOutcomes',
  'challenges',
];

const localizeExperience = (exp, lang) => {
  const localized = lang !== 'en' ? exp[lang] : null;
  if (!localized) return exp;
  const result = { ...exp };
  LOCALIZED_EXPERIENCE_FIELDS.forEach((field) => {
    result[field] = localized[field] || exp[field];
  });
  return result;
};

export const getWorkExperienceData = (lang = 'en') => {
  return workExperienceData.map(exp => localizeExperience(exp, lang));
};

export const getWorkExperienceById = (id, lang = 'en') => {
  const exp = workExperienceData.find(e => e.id === id);
  if (!exp) return undefined;
  return localizeExperience(exp, lang);
};

export const getWorkExperienceByCompanyAndRole = (company, role, lang = 'en') => {
  const exp = workExperienceData.find(e => e.company === company && e.role === role);
  if (!exp) return undefined;
  return localizeExperience(exp, lang);
};
